(function () {
  function perView(root) {
    var d = parseInt(root.getAttribute('data-amc-per-desktop') || '1', 10);
    var m = parseInt(root.getAttribute('data-amc-per-mobile') || '1', 10);
    if (typeof window !== 'undefined' && window.matchMedia) {
      if (window.matchMedia('(min-width: 1200px)').matches) return Math.max(1, d);
      if (window.matchMedia('(min-width: 768px)').matches) return Math.max(1, d);
      return Math.max(1, m);
    }
    return Math.max(1, d);
  }

  function initCarousel(root) {
    if (!root || root.dataset.amcInit === '1') return;
    var track = root.querySelector('[data-amc-track]');
    var slides = track ? track.querySelectorAll('[data-amc-slide]') : [];
    var dotsWrap = root.querySelector('[data-amc-dots]');
    var prevBtn = root.querySelector('[data-amc-prev]');
    var nextBtn = root.querySelector('[data-amc-next]');
    if (!track || !slides.length) return;

    root.dataset.amcInit = '1';

    var index = 0;
    var maxIndex = Math.max(0, slides.length - perView(root));
    var autoplayMs = parseInt(root.getAttribute('data-amc-autoplay-ms') || '0', 10);
    var timer = null;

    function updateDots() {
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-amc-dot]').forEach(function (dot, i) {
        var on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }

    function updateNav() {
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex;
    }

    function scrollToIndex(i, behavior) {
      index = Math.max(0, Math.min(i, maxIndex));
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft, behavior: behavior || 'smooth' });
      updateDots();
      updateNav();
    }

    function onScrollEnd() {
      var slide = slides[0];
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      var step = slide.offsetWidth + gap;
      if (!step) return;
      var guess = Math.round(track.scrollLeft / step);
      index = Math.max(0, Math.min(guess, maxIndex));
      updateDots();
      updateNav();
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onScrollEnd, 80);
    });

    if (dotsWrap) {
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-amc-dot]');
        if (!dot) return;
        var i = parseInt(dot.getAttribute('data-amc-dot'), 10);
        if (isNaN(i)) return;
        scrollToIndex(i);
        resetAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToIndex(index - 1);
        resetAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToIndex(index + 1);
        resetAutoplay();
      });
    }

    function resetAutoplay() {
      if (timer) window.clearInterval(timer);
      if (autoplayMs < 1000) return;
      timer = window.setInterval(function () {
        maxIndex = Math.max(0, slides.length - perView(root));
        scrollToIndex(index >= maxIndex ? 0 : index + 1);
      }, autoplayMs);
    }

    function onResize() {
      maxIndex = Math.max(0, slides.length - perView(root));
      scrollToIndex(Math.min(index, maxIndex), 'auto');
    }

    window.addEventListener('resize', onResize);
    updateDots();
    updateNav();
    resetAutoplay();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-amc-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-amc-carousel]').forEach(function (el) {
      delete el.dataset.amcInit;
    });
    boot(e.target);
  });
})();
